module.exports = function(locale, preview = false) {
  return `{
    articleCollection(limit: 150, locale:"${locale}", preview: ${preview}){
        items{
            sys {
                id
                firstPublishedAt
              }
              title
              shortDescription
              slug
              addedOn
              variant
              heroImage{
                title
                fileName
                url
                contentType        
              }
              facetCollection(limit: 20) {
                items {
                  sys {
                    id
                  }
                  name
                  title
                  facetCategory {
                    title
                    uniqueId
                  }
                }
              }
              breadcrumbTitle
              sitemapTitle
        }
    }
  }
    `;
};
